<template>
  <tr :class="computedClass">
    <slot :context="model.$item"></slot>
  </tr>
</template>
<script>
export default {
  props: ['model'],
  computed: {
    computedClass() {
      if (this.model.$diff) {
        switch (this.model.$diff.$status) {
          case 'removed':
            return 'removed';

          case 'new':
            return 'new';
        }
      }
      return '';
    }
  }
};
</script>

